import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ authority, children }) => {
  const token = localStorage.getItem("sessionToken");
  const authorities =
    JSON.parse(localStorage.getItem("authorities")) || [];

  // ❌ Not logged in
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // ❌ Logged in but no permission
  if (authority && !authorities.includes(authority)) {
    return <Navigate to="/dashboard" replace />;
  }

  // ✅ Allowed
  return children;
};

export default ProtectedRoute;
